export class ActionApprovalRule {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "operation",
            "baseName": "operation",
            "type": "ActionApprovalOperationType",
            "format": ""
        },
        {
            "name": "requiredApprovals",
            "baseName": "requiredApprovals",
            "type": "number",
            "format": ""
        },
        {
            "name": "approvalWindowHours",
            "baseName": "approvalWindowHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "executionWindowHours",
            "baseName": "executionWindowHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceSelector",
            "baseName": "resourceSelector",
            "type": "ActionApprovalRuleResourceSelector",
            "format": ""
        },
        {
            "name": "condition",
            "baseName": "condition",
            "type": "Condition",
            "format": ""
        },
        {
            "name": "approverIdpId",
            "baseName": "approverIdpId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "approverProviderGroupId",
            "baseName": "approverProviderGroupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "number",
            "format": ""
        },
        {
            "name": "exemptApiCredentials",
            "baseName": "exemptApiCredentials",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ActionApprovalRule.attributeTypeMap;
    }
    constructor() {
    }
}
